<div class="cpcontent">
  <h2>Events by Exercise</h2>

  <div *ngIf="!isAuthenticatedWithFirebase" class="mb-3">
    <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
  </div>

  <div *ngIf="isAuthenticatedWithFirebase">
    <div class="d-flex align-items-center mb-2 gap-3 flex-wrap">
      <button class="btn btn-sm btn-outline-secondary" (click)="loadEvents()" [disabled]="loading">
        {{ loading ? 'Loading...' : 'Reload' }}
      </button>
      <span class="text-muted small">Total events: {{ events.length }} | Data size: {{ eventsSizeKB | number:'1.0-1' }} KB</span>
      <span *ngIf="selectedExerciseId" class="badge bg-info">Selected: {{ selectedExerciseId }} ({{ exerciseEvents.length }})</span>
      <button *ngIf="selectedExerciseId" class="btn btn-sm btn-outline-dark" (click)="clearSelection()">Clear selection</button>
    </div>

    <div class="row">
      <div class="col-12 col-md-4 mb-3">
        <h5 class="mb-2">Exercises ({{ exercises.length }})</h5>
        <div class="list-group small exercise-list">
          <button type="button" *ngFor="let ex of exercises" class="list-group-item list-group-item-action"
                  [class.active]="ex.id === selectedExerciseId" (click)="selectExercise(ex.id)">
            <div class="d-flex justify-content-between align-items-center">
              <div class="me-2 small text-nowrap" style="min-width:135px;">{{ ex.latestDatetime }}</div>
              <div class="flex-grow-1 text-truncate">{{ ex.id }}</div>
              <span class="badge bg-secondary ms-2">{{ ex.count }}</span>
            </div>
          </button>
        </div>
      </div>
      <div class="col-12 col-md-8">
        <h5 *ngIf="selectedExerciseId" class="mb-2">Events for {{ selectedExerciseId }} ({{ exerciseEvents.length }})</h5>
        <p *ngIf="!selectedExerciseId" class="text-muted">Select an exercise to view its events.</p>
        <div *ngIf="selectedExerciseId" class="table-responsive" style="max-height:60vh; overflow:auto;">
          <table class="table table-sm table-striped table-hover align-middle">
            <thead class="table-light position-sticky top-0">
              <tr>
                <th style="width:140px;">Datetime</th>
                <th>Type</th>
                <th>Player</th>
                <th>Id</th>
                <th>Validity</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let wrap of exerciseEventsHydrated">
                <td>{{ wrap.raw.datetime }}</td>
                <td>{{ wrap.raw.type }}</td>
                <td>{{ wrap.raw.playerid }}</td>
                <td class="text-truncate" style="max-width:120px;" title="{{ wrap.raw.id }}">{{ wrap.raw.id }}</td>
                <td>
                  <span *ngIf="wrap.isValid" class="badge bg-success">OK</span>
                  <span *ngIf="!wrap.isValid" class="badge bg-danger" title="Missing/Extra properties">Invalid</span>
                </td>
                <td>
                  <details>
                    <summary class="small">View</summary>
                    <div class="small">
                      <strong>Raw:</strong>
                      <pre class="mb-1 small">{{ wrap.raw | json }}</pre>
                      <strong>Hydrated (defaults applied):</strong>
                      <pre class="mb-1 small">{{ wrap.hydrated | json }}</pre>
                      <div *ngIf="!wrap.isValid" class="text-danger mb-1">
                        <div *ngIf="wrap.missing.length">Missing: {{ wrap.missing.join(', ') }}</div>
                        <div *ngIf="wrap.extra.length">Extra: {{ wrap.extra.join(', ') }}</div>
                      </div>
                    </div>
                  </details>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
